export interface ClientConfig {
  apigHost: string,
  apiRegion: string,
  appClientId: string,
  authRegion: string,
  googleMapsApiKey: string | null,
  incomingMediaBucket: string,
  cognitoEndpoint: string,
  userPoolId: string,
  awsAccountId: string,
}

export const isClientConfig = (obj: unknown): obj is ClientConfig => {
  if (obj == null || typeof obj !== 'object') {
    return false;
  }
  const cc = obj as Partial<ClientConfig>;
  return cc.appClientId != null;
};
